import { rgba } from 'polished'

import { width, maxWidth } from 'common.styles'

export const rootStyle = (theme) => {
  const { paper } = theme.palette.background
  const { black } = theme.palette.common

  return {
    background: `${rgba(paper, 0.8)} !important`,
    backdropFilter: 'saturate(180%) blur(20px)',
    position: 'sticky',
    bottom: 0,
    zIndex: 100,
    boxShadow: `0 -8px 16px ${rgba(black, 0.025)}`,
    transition: 'ease-out 0.2s',
    transitionProperty: 'transform, opacity',
  }
}

export const mainStyle = () => ({
  ...width(),
  ...maxWidth,
  background: 'transparent'
})

export const titleStyle = () => ({
  '&& .MuiAccordionSummary-content': {
    marginBlock: 1.5,
    marginInline: 0,
    flexDirection: 'column'
  }
})

export const subtitleStyle = () => ({
  marginBottom: 1.5
})

export const captionStyle = () => ({
  display: 'flex',
  marginBottom: 1.25,
  gap: 1,
})

export const captionIconStyle = () => ({
  marginTop: 0.75
})

export const contentStyle = () => ({
  paddingTop: 0,
  paddingBottom: 1,
  flexDirection: 'column'
})
